import { Component, Input, OnInit } from '@angular/core';
import {
	LimiteGlobal,
	LimiteGlobalRetornoProduto,
} from '../../models/limite-global';

@Component({
	selector: 'app-card-distribuicao-limite-lg',
	templateUrl: './card-distribuicao-limite-lg.component.html',
	styleUrls: ['./card-distribuicao-limite-lg.component.styl'],
})
export class CardDistribuicaoLimiteLgComponent implements OnInit {
	@Input() limiteGlobal: LimiteGlobal;
	produtos: LimiteGlobalRetornoProduto[] = [];

	private readonly codCDC = 'CDC';
	private readonly codCartaoCredito = 'CARTÃO DE CRÉDITO';
	private readonly codsProdutos = [this.codCDC, this.codCartaoCredito];

	constructor() {}

	sortCod = (
		valueA: LimiteGlobalRetornoProduto,
		valueB: LimiteGlobalRetornoProduto
	) => (valueA.Codigo > valueB.Codigo ? 1 : -1);

	ngOnInit(): void {
		this.produtos = this.limiteGlobal.Produtos.filter((f) =>
			this.codsProdutos.includes(f.Codigo)
		).sort(this.sortCod);
	}

	public getDescricaoProduto(produto: LimiteGlobalRetornoProduto): string {
		switch (produto.Codigo) {
			case this.codCDC:
				return 'Em uso no financiamento';
			case this.codCartaoCredito:
				return 'Limite de crédito no cartão';
			default:
				return '';
		}
	}

	public getIconProduto(produto: LimiteGlobalRetornoProduto): string {
		switch (produto.Codigo) {
			case this.codCDC:
				return '../../../../../assets/icons/car2-lg.svg';
			case this.codCartaoCredito:
				return '../../../../../assets/icons/cartao-lg.svg';
			default:
				return '';
		}
	}

	public get valorAprovado(): number {
		return this.limiteGlobal.ValorUtilizado;
	}

	public get valorDisponivel(): number {
		return this.limiteGlobal.ValorDisponivel;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limite-global/components/card-distribuicao-limite-lg/card-distribuicao-limite-lg.component.ts